<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Hersteller bearbeiten') }}</h1>
        </div>

        <p>
            <a :href="manufacturer.permalink" target="_blank">{{ manufacturer.permalink }}</a>
        </p>

        <div class="">
            <form @submit.prevent="form.put(route('admin.manufacturers.update', manufacturer))">
                <form-fields 
                    :form="form" 
                    :manufacturer="manufacturer" 
                    :countries="countries" 
                    :manufacturers="manufacturers" 
                    />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'manufacturer',
            'countries',
            'manufacturers',
            'aliased_id',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.manufacturer.name,
                    slug: this.manufacturer.slug,
                    short_name: this.manufacturer.short_name,
                    aliases_checked: this.manufacturer.aliases_checked,
                    aliased_id: this.manufacturer.aliased_id || this.aliased_id,
                    meta_title: this.manufacturer.meta_title,
                    meta_description: this.manufacturer.meta_description,
                    description: this.manufacturer.description,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>